export const ALL_SEASONS = "All seasons";



// WEBPACK FOOTER //
// ./src/features/director/pages/seasons/components/seasons-sport-editor/constants.ts